<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card
        title="Roles"
      >
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Showing</label>
              <v-select
                v-model="perPage"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
                :options="perPageOptions"
              />
              <label>entries</label>
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Search..."
                />
                <b-button
                  v-if="$ability.can(constants.action.permissionRoleAdd, constants.resource.role)"
                  v-b-modal.modal-role
                  variant="primary"
                  @click="getRole(addRoleInput)"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_ADD_ROLE') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="roles"
          class="position-relative"
          :fields="rolesFields"
          :items="rolesData"
        >
          <template #cell(action)="data">
            <feather-icon
              v-if="$ability.can(constants.action.permissionRoleAdd, constants.resource.role)"
              v-b-modal.modal-role
              icon="EditIcon"
              @click="getRole(data.item)"
            />
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing {{ from }} to {{ to }} of {{ totalPages }} entries</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
        <role-modal
          :role-data="editData"
          :modal-loads="modalLoader"
          :show="!modalLoader"
          :reload-method="getRoles"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTable, BRow, BCol, BFormInput, BButton, BPagination,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import constants from '@/app-configs/constants'
import RoleModal from './RoleModal.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BRow,
    BCol,
    vSelect,
    BFormInput,
    BButton,
    BPagination,
    RoleModal,
  },
  data() {
    return {
      loader: false,
      rolesFields: [
        { key: 'id', sortable: true },
        { key: 'title', sortable: true },
        'Action',
      ],
      rolesData: [],
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      editData: {},
      addRoleInput: { id: 0, title: '' },
      modalLoader: true,
      constants,
    }
  },
  watch: {
    searchQuery: {
      handler() {
        this.getRoles()
      },
    },
    currentPage: {
      handler() {
        this.getRoles()
      },
    },
    perPage: {
      handler() {
        this.getRoles()
      },
    },
  },
  created() {
    this.getRoles()
    this.actionColumn()
  },
  methods: {
    async getRoles() {
      try {
        this.loader = true
        const roles = await axios.get('/role-management/get-roles', {
          params: {
            perPage: this.perPage,
            q: this.searchQuery,
            page: this.currentPage,
          },
        })
        if (roles.status) {
          this.rolesData = roles.data.data.data
          this.totalPages = roles.data.data.total
          this.from = roles.data.data.from
          this.to = roles.data.data.to
          this.currentPage = roles.data.data.current_page
          this.loader = false
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    async getRole(item) {
      this.modalLoader = true

      const data = await axios.get('role-management/get-role-abilities', { params: { role: item.name } })
      if (data.status === 200) {
        this.editData = item
        this.editData.permissions = data.data.data
        this.modalLoader = false
      }

      console.log('***', this.editData)
      // const res = this.rolesData.filter(it => it.title === 'Super Admin')
    },
    actionColumn() {
      if (this.$ability.cannot(this.constants.action.permissionRoleEdit, this.constants.resource.role)) {
        this.rolesFields.splice(2)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
